.uc-editorial .church-hero h1 {
  font-size: clamp(48px, 6.7vw, 80px);
  max-width: 980px;
  margin: 25px auto;
  letter-spacing: -0.055em;
}
.uc-editorial .church-intro {
  max-width: 710px;
  font-size: 20px;
}
.uc-challenges {
  margin-top: 38px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 32px;
}
.uc-challenges h3 {
  font-size: 20px;
  margin: 22px 0 14px;
}
.uc-challenges p {
  font-size: 15px;
}
.uc-tool-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-top: 36px;
}
.uc-tool-grid article {
  background: #f5f5f7;
  padding: 30px;
  border-radius: 20px;
}
.uc-tool-grid h3 {
  font-size: 21px;
  margin: 30px 0 14px;
}
.uc-tool-grid p {
  font-size: 15px;
}
.uc-capabilities {
  list-style: none;
  padding: 0;
  margin: 34px 0 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px 40px;
}
.uc-capabilities li {
  position: relative;
  padding-left: 26px;
  font-size: 14px;
  line-height: 1.6;
  color: #515155;
}
.uc-capabilities li:before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #1d1d1f;
}
.uc-prompts {
  margin-top: 36px;
}
.uc-prompts details {
  padding: 24px 0;
  border-top: 1px solid #e5e5e7;
}
.uc-prompts summary {
  font-size: 19px;
  font-weight: 600;
  cursor: pointer;
  list-style: none;
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.uc-prompts summary::-webkit-details-marker {
  display: none;
}
.uc-prompts details[open] summary span {
  transform: rotate(45deg);
}
.uc-prompts p {
  max-width: 880px;
  margin: 20px 0 !important;
  font-size: 16px;
}
.uc-prompts button {
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  min-height: 42px;
  border: 1px solid #d2d2d7;
  border-radius: 999px;
  background: #fff;
  padding: 10px 20px;
  cursor: pointer;
}
.uc-business .church-work-grid h3 {
  margin: 0 0 16px;
}
.uc-business-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 26px;
  margin: 28px 0 15px;
}
.uc-business-actions .church-text-link {
  margin: 0;
}
.uc-related > div {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}
.uc-related a {
  padding: 24px;
  border: 1px solid #e5e5e7;
  border-radius: 15px;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  text-decoration: none;
  font-weight: 500;
}
.uc-related a:hover {
  background: #f5f5f7;
}
.uc-editorial button:focus-visible {
  outline: 2px solid #1d1d1f;
  outline-offset: 5px;
}
@media (max-width: 800px) {
  .uc-challenges,
  .uc-tool-grid {
    grid-template-columns: 1fr;
  }
  .uc-capabilities,
  .uc-related > div {
    grid-template-columns: 1fr;
  }
  .uc-challenges {
    gap: 28px;
  }
  .uc-editorial .church-intro {
    font-size: 17px;
  }
  .uc-tool-grid article {
    padding: 26px;
  }
  .uc-tool-grid h3 {
    margin-top: 20px;
  }
}

.uc-hub .uc-hub-hero {
  padding-bottom: 56px;
}
.uc-hub-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 0 48px;
}
.uc-hub-filters button {
  border: 1px solid #dedee2;
  background: #fff;
  color: #55555b;
  border-radius: 24px;
  padding: 11px 19px;
  font: inherit;
  font-size: 14px;
  cursor: pointer;
}
.uc-hub-filters button[aria-pressed="true"] {
  background: #1d1d1f;
  color: #fff;
  border-color: #1d1d1f;
}
.uc-hub-filters button:focus-visible,
.uc-hub-card:focus-visible {
  outline: 3px solid #0071e3;
  outline-offset: 5px;
}
.uc-hub-results {
  min-height: 240px;
}
.uc-hub-group {
  margin-bottom: 72px;
}
.uc-hub-group h2 {
  margin: 0 0 24px;
  font-size: 32px;
  letter-spacing: -1px;
}
.uc-hub-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 24px;
}
.uc-hub-card {
  display: block;
  text-decoration: none;
  color: #1d1d1f;
  border-radius: 22px;
  overflow: hidden;
  border: 1px solid #e7e7eb;
  background: #f8f8fa;
  transition: box-shadow 180ms ease;
}
.uc-hub-card:hover {
  box-shadow: 0 12px 36px #0000000d;
}
.uc-hub-card img {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  border-bottom: 1px solid #e7e7eb;
}
.uc-hub-card > div {
  padding: 24px;
}
.uc-hub-card h3 {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 12px;
  font-size: 21px;
  letter-spacing: -0.5px;
}
.uc-hub-card p {
  margin: 0;
  color: #6e6e73;
  font-size: 15px;
  line-height: 1.65;
}
.uc-hub-card-action {
  display: block;
  margin-top: 24px;
  color: #0066cc;
  font-size: 13px;
}
@media (max-width: 900px) {
  .uc-hub-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 600px) {
  .uc-hub-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .uc-hub-filters {
    padding-bottom: 36px;
    gap: 7px;
  }
  .uc-hub-filters button {
    padding: 10px 15px;
  }
  .uc-hub-group {
    margin-bottom: 48px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .uc-hub-card {
    transition: none;
  }
}
